"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/checkbox/checkbox-context.tsx
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, );
var useCheckboxContext = ctx.useContext;
var useCheckboxScopedContext = ctx.useScopedContext;
var useCheckboxProviderContext = ctx.useProviderContext;
var CheckboxContextProvider = ctx.ContextProvider;
var CheckboxScopedContextProvider = ctx.ScopedContextProvider;







exports.useCheckboxContext = useCheckboxContext; exports.useCheckboxScopedContext = useCheckboxScopedContext; exports.useCheckboxProviderContext = useCheckboxProviderContext; exports.CheckboxContextProvider = CheckboxContextProvider; exports.CheckboxScopedContextProvider = CheckboxScopedContextProvider;
